import {Sound} from '../../../../shared/scripts/Sound'
import {UIHeaderProfileController} from './UIHeaderProfileController'
import {CA} from '../../../../shared/scripts/analytics/Analytics'
import {UIAjaxWrapper} from '../../../../shared/scripts/network/UIAjaxWrapper'
import {UIAPIEndpoints} from '../../../../shared/scripts/network/UIAPIEndpoints'
import {UIWHeaderCoinController} from './UIWHeaderCoinController'
import {UIUrlParameterNames} from '../../../../shared/scripts/ui_html/UIUrlController'
import {removeURLParams} from '../../../../shared/scripts/ui_utils/Utils'
import {ViewPopupLogin} from '../../../../shared/scripts/ui_popup/ui_popup_membership_incentive/ViewPopupLogin'
import {ErrorController} from '../../../../../shared/errors/ErrorController'
import {UIErrorHandler} from '../../../../shared/scripts/errors/UIErrorHandler'
import {notificationController} from '../../../../shared/scripts/EntryShared'
import {UIHeaderController} from '../../../../shared/scripts/ui_html/header/UIHeaderController'
import {stripOAuthTokenFromUrl} from '../../../../shared/scripts/ui_utils/TestableClientUtils'
import {UINotificationPanelController} from '../../../../shared/scripts/notifications/UINotificationPanelController'
import {AjaxDataTypes} from '../../../../../shared/AjaxDataTypes'
import {getHomepageUrlWithParameter, navigateToPage} from '../../../../shared/scripts/ui_utils/ClientUtils'
import {UIEntryUrlParameterController} from '../../../../shared/scripts/UIEntryUrlParameterController'
import {ClientUserState} from '../../../../shared/scripts/ClientUserState'

export class UIWHeaderController extends UIHeaderController {
    protected storeButton: HTMLLinkElement
    protected lobbyButton: HTMLLinkElement
    protected homeButton: HTMLLinkElement
    protected leaderboardButton: HTMLLinkElement
    protected coinController: UIWHeaderCoinController
    readonly mobileMenu: HTMLDivElement
    readonly profileController: UIHeaderProfileController
    readonly container: HTMLHeadingElement
    readonly notificationPanelController?: UINotificationPanelController | undefined

    homeButtonAction: (event: MouseEvent) => void
    lobbyButtonAction: (event: MouseEvent) => void

    constructor() {
        super()
        this.container = document.getElementById('page_header') as HTMLHeadingElement
        this.profileController = new UIHeaderProfileController()

        this.setButtonsActions()
        this.setCoinController()

        this.mobileMenu = document.getElementById('lobby_mobile_menu') as HTMLDivElement
        this.initMobileMenu()
        stripOAuthTokenFromUrl()
        this.coinController.registerOnClickListenerForStore()
        void this.addFriendRequestsToNotificationPanel()

        UIWHeaderController.displayRedirectErrors()
        UIWHeaderController.displayLoginPopupBasedOnUrlSearchParams()

        this.notificationPanelController = new UINotificationPanelController()
    }

    protected setButtonsActions() {
        this.storeButton = document.getElementById('header_navigation_store') as HTMLLinkElement
        this.homeButton = document.getElementById('header_navigation_home') as HTMLLinkElement
        this.homeButton.onclick = (event: MouseEvent) => {
            this.activateHomeButton()
            if(this.homeButtonAction == undefined) return
            this.homeButtonAction(event)
        }
        this.lobbyButton = document.getElementById('header_navigation_lobby') as HTMLLinkElement
        this.lobbyButton.onclick = (event: MouseEvent) => {
            this.activateLobbyButton()
            if(this.lobbyButtonAction == undefined) {
                navigateToPage(getHomepageUrlWithParameter(UIUrlParameterNames.Lobby, UIEntryUrlParameterController.DEFAULT_PARAMETER_VALUE))
                return
            }
            this.lobbyButtonAction(event)
        }
    }

    protected setCoinController() {
        this.coinController = new UIWHeaderCoinController()
    }

    // eslint-disable-next-line class-methods-use-this
    private async addFriendRequestsToNotificationPanel() {
        if(ClientUserState.userState == undefined) return

        const friendRequestsResponse = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiFriendRequestsReceived(), undefined)
        if(friendRequestsResponse == undefined) return
        const friendRequests = friendRequestsResponse.json as AjaxDataTypes.FriendRequestReceivedData[]
        const friendRequestsNumber: number = friendRequests !== undefined ? friendRequests.length : 0
        if(friendRequestsNumber === 0) return

        if(notificationController === undefined) return

        for(const friendRequestReceived of friendRequests) {
            this.notificationPanelController?.addFriendRequestNotification(friendRequestReceived.username, new Date(friendRequestReceived.dateCreated))
        }
    }

    hide() {
        this.container.style.display = 'none'
    }

    show() {
        this.container.style.display = 'flex'
    }

    private initMobileMenu() {
        this.initBurgerButton()
        this.initMenuCloseButton()
    }

    private initBurgerButton() {
        const burgerButton = document.getElementById('lobby_mobile_burgerbutton')
        if(burgerButton == undefined) return
        burgerButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            CA.sendGoogleAnalyticsEvent(CA.Category.Mobile, CA.Label.MobileClickedBurgeButton)
            this.openMobileMenu()
        }
    }

    private initMenuCloseButton() {
        const menuCloseButton = document.getElementById('lobby_mobile_menuclosebutton')
        if(menuCloseButton == undefined) return
        menuCloseButton.onclick = () => {
            Sound.playSound(Sound.SoundType.Click)
            this.closeMobileMenu()
        }
    }

    setHomeButtonAction(homeButtonAction: (event: MouseEvent) => void) {
        this.homeButtonAction = homeButtonAction
    }

    setLobbyButtonAction(lobbyButtonAction: (event: MouseEvent) => void) {
        this.lobbyButtonAction = lobbyButtonAction
    }

    activateHomeButton() {
        this.addActiveClassToHomeButton()
        this.removeActiveClassFromLobbyButton()
    }

    activateLobbyButton() {
        this.addActiveClassToLobbyButton()
        this.removeActiveClassFromHomeButton()
    }

    openMobileMenu() {
        this.mobileMenu.classList.add('active')
    }

    closeMobileMenu() {
        this.mobileMenu.classList.remove('active')
    }

    private removeActiveClassFromHomeButton() {
        if(this.homeButton != undefined) this.homeButton.classList.remove('active')
    }

    private removeActiveClassFromLobbyButton() {
        if(this.lobbyButton != undefined) this.lobbyButton.classList.remove('active')
    }

    private addActiveClassToLobbyButton() {
        if(this.lobbyButton != undefined) this.lobbyButton.classList.add('active')
    }

    private addActiveClassToHomeButton() {
        if(this.homeButton != undefined) this.homeButton.classList.add('active')
    }

    private static displayRedirectErrors() {
        const urlSearchParams = new URLSearchParams(window.location.search)

        const error = urlSearchParams.get('error')
        if(error == null) return

        const parsedError = JSON.parse(error)
        const deserializedError = ErrorController.deserializeErrorData(parsedError)

        UIErrorHandler.handleError(deserializedError)
        removeURLParams()
    }

    private static displayLoginPopupBasedOnUrlSearchParams() {
        const urlSearchParams = new URLSearchParams(window.location.search)
        if(!urlSearchParams.has('login-popup')) return

        new ViewPopupLogin()
        removeURLParams()
    }
}
